module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAtElEQVRIS2NkoDFgpLH5DMPIgv/hihcYGBj1qRJk//9fYFx13xBkFjyI/ocr/aeK4VBDGFfeA5uNsKA38z8DryB17Pj8noGxeDqaBbOqqOuDtDY0C2geRDS3gOZBRDcL9q7AnZKcIyByRKhhxIhkmA+I0EyZBcTkBCIcgdsHNLeACNdRFkQ0t4CYICJCDWYcTC2+z8DKrkCEXsJKfv98wJjdq4hSmhLWRZ6KYVRlkhcAhHUBADFBXBmKhskcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/newsfeed 3.png
// module id = p0r7
// module chunks = 0